module.exports = __webpack_public_path__ + "c0cfbc2914a3b7f6a3540ede77f207ed.svg";